export default __webpack_public_path__ + "static/media/user-07.2f589a83.jpg";